module.exports = __webpack_public_path__ + "img/BRCA2_Mono.Macro.bad355c7.png";